import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

const quizDialogStyles = css`
  margin: 0 !important;
  max-height: unset;
  border-radius: 0;
`;

export const QUIZ_PLAYER_DIALOG_CLASSES = {
  paper: cn('my-32 mx-24 w-full max-w-none h-full', quizDialogStyles),
};

export const QUIZ_PLAYER_BOTTOMSHEET_CLASSES = {
  rootClassName: 'flex flex-col drawer-root relative h-full overflow-hidden',
  // h-full here would resolve against a `position: fixed` ancestor, which on iOS
  // Safari is sized off the layout viewport (ignores the collapsible bottom
  // toolbar) — use 100dvh so it tracks the actual visible viewport and bottom
  // actions (e.g. Submit Quiz) aren't hidden behind Safari's own UI.
  paper: 'shadow-none bg-transparent h-[100dvh]',
  containerClassName: 'bg-bg-primary h-full',
};
